export default "__VITE_ASSET__BqXX0eKp__"